import apiClient from "./axiosClient";

const sendGetStartedEmailRequest = async (
  firstName: string,
  programShortName: string,
  programInstnm: string,
  programURL: string,
  getStartedUrl: string,
  seekerEmail: string,
): Promise<string> => {
  return await apiClient
    .post('emails/get-started', {
      firstName,
      programShortName,
      programInstnm,
      programURL,
      seekerEmail,
      getStartedUrl
    })
    .then((res) => res.data);
};

export default sendGetStartedEmailRequest;